import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-critical",
  "use": "icon-critical-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-critical\"><g id=\"icon-critical_fill\"><path d=\"M12,.5A11.5,11.5,0,1,0,23.5,12,11.5,11.5,0,0,0,12,.5Zm1.44,18.69H10.56V16.31h2.88Zm0-5.75H10.56V4.81h2.88Z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol